<template>
  <b-overlay :show="loading">
    <vs-row
      :class="{ selected: file.febosId === selectedFile }"
      class="p-3 mt-2 shadow-sm bg-white"
    >
      <vs-col vs-lg="11">
        <vs-row>
          <vs-col
            class="text-center text-primary"
            vs-lg="2"
          >
            <div
              data-cy="file-number"
              :class="{ 'text-success': wasCopied }"
              class="cursor-pointer"
              @click="copyToClipboard(file.febosId, file.numero)"
            >
              {{
                file.numero.includes('-') ?
                  file.numero.substring(0, file.numero.lastIndexOf('-')) : file.numero
              }}<br />
              {{
                file.numero.includes('-') ? file.numero.split('-')
                  .pop() : ''
              }}
            </div>
          </vs-col>
          <vs-col
            vs-lg="2"
            data-cy="file-status"
          >
            <vs-chip
              v-if="file.estado === 1"
              title="creado"
            >
              <vs-avatar
                icon="mail_outline"
                color="#43C3B9"
              />
              Creado
            </vs-chip>
            <vs-chip
              v-if="file.estado === 2"
              title="ingresado"
            >
              <vs-avatar
                icon="check"
                color="#ff9f43"
              />
              Ingresado
            </vs-chip>
            <vs-chip
              title="Borrador"
              v-if="file.estado === 3"
            >
              <vs-avatar
                icon="query_builder"
                color="#87579e"
              />
              Borrador
            </vs-chip>
            <vs-chip
              title="Descartado"
              v-if="file.estado === 101"
            >
              <vs-avatar
                icon="delete"
                color="gray"
              />
              Descartado
            </vs-chip>
            <div
              @click="getFlowDetails"
              style="cursor:pointer;"
            >
              <vs-chip
                title="En flujo"
                v-if="file.estado === 6"
              >
                <vs-avatar
                  icon="query_builder"
                  color="#ffc107"
                />
                En flujo
              </vs-chip>
            </div>
            <vs-chip
              title="Anulado"
              v-if="file.estado === 8 || file.estado === '8'"
            >
              <vs-avatar
                icon="do_not_disturb"
                color="#DB1D2A"
              />
              Anulado
            </vs-chip>
            <vs-chip
              title="Tramitado"
              v-if="file.estado === 10"
            >
              <vs-avatar
                icon="gavel"
                color="#03a9f4"
              />
              Tramitado
            </vs-chip>
            <vs-chip
              title="Numerado"
              v-if="file.estado === 15"
            >
              <vs-avatar
                icon="gavel"
                color="#3f51b5"
              />
              Numerado
            </vs-chip>
            <vs-chip
              title="Rechazado"
              v-if="file.estado === 5"
            >
              <vs-avatar
                icon="thumb_down"
                color="#CE4B4B"
              />
              Rechazado
            </vs-chip>
            <vs-chip
              title="Aprobado"
              v-if="file.estado === 12"
            >
              <vs-avatar
                icon="thumb_up"
                color="#26bd6a"
              />
              Aprobado
            </vs-chip>
            <vs-chip
              title="Finalizado"
              v-if="file.estado === 9 || file.estado === '9'"
            >
              <vs-avatar
                icon="move_to_inbox"
                color="#A04E4E"
              />
              Finalizado
            </vs-chip>
            <vs-chip
              title="En contraloría"
              v-if="file.estado === 70 || file.estado === '70'"
            >
              <vs-avatar
                icon="track_changes"
                color="#3f51b5"
              />
              Contraloría
            </vs-chip>
            <vs-chip
              title="Archivado"
              v-if="file.estado === 100 || file.estado === '100'"
            >
              <vs-avatar
                icon="move_to_inbox"
                color="#607d8b"
              />
              Archivado
            </vs-chip>
          </vs-col>
          <vs-col vs-lg="8">
            <vs-row>
              <vs-col
                vs-lg="3"
                vs-sm="3"
                vs-xs="12"
              >
                <b
                  v-tooltip="'Remitente'"
                  v-if="!isUseExternalForm"
                >
                  {{ file.compradorArea | capitalize }}
                </b>
                <b
                  v-tooltip="'Remitente'"
                  v-if="isUseExternalForm && isIntOrExtEXP"
                >
                  {{ (isSenderType
                    ? file.compradorCodigo
                    : file.solicitanteGrupoNombre) | capitalize }}
                </b>
                <div v-b-tooltip="file.emisorContactoNombre">
                  {{ file.emisorContactoNombre | truncate(30) }}
                </div>
              </vs-col>
              <vs-col
                vs-lg="3"
                vs-sm="3"
                vs-xs="12"
              >
                {{ file.solicitanteGrupoNombre }}
                <small
                  v-if="file.solicitanteNombre"
                  class="d-block"
                  v-tooltip="`${file.solicitanteNombre}`"
                >
                  {{ file.solicitanteNombre | truncate(20) }}
                </small>
              </vs-col>
              <vs-col
                vs-lg="3"
                vs-sm="3"
                vs-xs="12"
                v-if="onPendingFiles"
              >
                {{ file.derivadoPor }}
              </vs-col>
              <vs-col
                vs-lg="6"
                vs-sm="3"
                vs-xs="12"
                v-if="!onPendingFiles"
              >
                {{ file.nombreDescriptivo }}
              </vs-col>
              <vs-col
                vs-lg="3"
                vs-sm="3"
                vs-xs="12"
                v-if="onPendingFiles"
              >
                {{ file.nombreDescriptivo }}
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <RowLargeScreen
          v-if="screenSizeFull"
          :file="file"
          :on-general-files="onGeneralFiles"
          :on-pending-files="onPendingFiles"
        />
        <RowSmallScreen
          v-if="!screenSizeFull"
          :file="file"
          :on-general-files="onGeneralFiles"
          :on-pending-files="onPendingFiles"
        />
      </vs-col>
      <vs-col
        vs-lg="1"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
      >
        <slot
          name="actions"
          v-bind:file="file"
        >
          <FileOptions
            :ref="'file-options-' + file.febosId"
            :file="file"
            :is-draft="isDraft"
            :is-assigned="isAssigned"
            :is-processed="isProcessed"
            :is-cancelled="isCancelled"
            :is-archivable="isArchivable"
            :is-numbered="isNumbered"
            :is-on-control="isOnControl"
            :watch-process-file="watchProcessFile"
            :is-responsible="isResponsible"
            :on-pending-files="onPendingFiles"
            :on-general-files="onGeneralFiles"
            :on-pre-salida="onPreSalida"
            :on-entered-files="onEnteredFiles"
            :on-incomplete-files="canCompleteData"
            :is-intern-file="isInternFile"
            :can-assign-me-file="canAssignMeFile"
            :can-process="canProcess"
            :can-process-answer="canProcessAnswer"
            :can-cancel="canCancel"
            :can-cancel-admin="canCancelAdmin"
            :can-send-to-flow="canSendToFlow"
            :select-file="selectFile"
            :is-response="isResponse"
            :can-edit-file="canEditFile"
            :can-edit-file-wizard="canEditFileWizard"
            :can-send-doc-digital="canSendDocDigital"
            :can-respond="canRespond"
            :can-recover="canRecover"
          />
        </slot>
      </vs-col>
    </vs-row>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import FileOptions from '@/febos/chile/dnt/components/files/FileOptions';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import RowSmallScreen from '@/febos/chile/dnt/components/files/RowSmallScreen';
import RowLargeScreen from '@/febos/chile/dnt/components/files/RowLargeScreen';
import {
  AGUAS_ANDINAS, CONVENCION, GORE_VALPARAISO, SERCOTEC, SISS
} from '@/constants/companies';

export default {
  components: {
    FileOptions,
    RowSmallScreen,
    RowLargeScreen
  },
  mixins: [CopyToClipboard],
  data() {
    const { view } = this.$route.params;
    return {
      view,
      loading: false
    };
  },
  props: [
    'file',
    'onPendingFiles',
    'onGeneralFiles',
    'onSupportFiles',
    'onProcessedFiles',
    'onEnteredFiles',
    'onPreSalida',
    'onIncompleteFiles',
    'selectFile'
  ],
  computed: {
    ...mapGetters('Dnts', ['selectedFile']),
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    screenSizeFull() {
      return window.innerWidth > 1024;
    },
    isIntOrExtEXP() {
      const configuredForms = ['int', 'ext'];
      return configuredForms.includes(this.file.claseMercadoPublico);
    },
    isUseExternalForm() {
      return [GORE_VALPARAISO.iut, SISS.iut, SERCOTEC.iut].includes(this.company.iut);
    },
    isSenderType() {
      const senderTypes = ['Ciudadano/a', 'Persona jurídica', 'Organismo del estado', 'Proveedores'];
      if (!this.file?.compradorCodigo) return false;
      return senderTypes.includes(this.file.compradorCodigo);
    },
    isAguasAndinas() {
      return this.company.iut === AGUAS_ANDINAS.iut;
    },
    isConvention() {
      return this.company.iut === CONVENCION.iut;
    },
    isDraft() {
      return this.file.estado === 3;
    },
    canEditFile() {
      if (this.view === 'pendientes-unidad') {
        return false;
      }
      return this.file.estado === 1 || this.file.estado === 2
        || (this.file.estado === 9 && this.file.solicitanteCodigo === 'si');
    },
    canEditFileWizard() {
      if (this.view === 'pendientes-unidad') {
        return false;
      }
      if (this.isUseExternalForm) {
        return (this.file.estado === 1 || this.file.estado === 2)
          && this.file.transporteEmbalajeTara !== 'inputDocForm';
      }

      return (this.file.estado === 1 || this.file.estado === 2)
        && this.file.estadoCodigoEstadoSistema !== 1
        && this.file.transporteEmbalajeTara !== 'inputDocForm' && !this.file.transporteEmbalajeSello;
    },
    canAssignMeFile() {
      if (this.view === 'pendientes-unidad') {
        return !this.isResponsible;
      }
      return false;
    },
    isAssigned() {
      return this.file.enGrupo === 'NO';
    },
    isArchivable() {
      return this.file.estado === 10 || this.file.estado === 9;
    },
    watchProcessFile() {
      return this.file.estado === 8
        || this.file.estado === 9 || this.file.estado === 100;
    },
    isResponsible() {
      return this.file.enResponsable === 'SI';
    },
    isProcessed() {
      return this.file.estado === 9;
    },
    isNumbered() {
      return this.file.estado === 15;
    },
    isOnControl() {
      return this.file.estado === 70;
    },
    isCancelled() {
      return this.file.estado === 8;
    },
    isResponse() {
      return this.file.estadoCodigoEstadoSistema === 1;
    },
    isInternFile() {
      return this.file.claseMercadoPublico === 'numInt'
        || this.file.claseMercadoPublico === 'numOf';
    },
    isSiss() {
      return this.company.iut === SISS.iut;
    },
    canProcess() {
      return (this.file.estado !== 3 && this.onGeneralFiles && this.file.claseMercadoPublico === 'int'
          && this.file.enGrupo === 'NO' && this.file.estado !== 9 && this.file.estado !== 8
          && this.file.solicitanteDocumentoId === this.currentUserId)
        || (this.onPendingFiles && this.isConvention);
    },
    canProcessAnswer() {
      return (this.file.estado !== 3 && this.file.estado !== 6 && this.onGeneralFiles
        && this.file.claseMercadoPublico === 'ext'
        && this.file.enGrupo === 'NO' && this.file.estado !== 9 && this.file.estado !== 8);
    },
    canCancel() {
      return this.file.estado !== 3 && this.onGeneralFiles && this.file.enGrupo === 'NO'
        && this.file.estado !== 9 && this.file.estado !== 8
        && this.file.solicitanteDocumentoId === this.currentUserId && this.file.estado !== 10
        && this.file.estado !== 15;
    },
    canCancelAdmin() {
      if (this.isConvention) {
        return this.file.estado !== 3 && this.onGeneralFiles && this.file.enGrupo === 'NO'
          && this.file.estado !== 8 && this.file.estado !== 10
          && this.file.estado !== 15;
      }
      return this.file.estado !== 3 && this.onGeneralFiles && this.file.enGrupo === 'NO'
        && this.file.estado !== 9 && this.file.estado !== 8 && this.file.estado !== 10
        && this.file.estado !== 15;
    },
    canSendToFlow() {
      return this.onGeneralFiles && this.file.enGrupo === 'NO'
        && this.file.estado === 1 && this.file.solicitanteDocumentoId === this.currentUserId
        && (this.file.claseMercadoPublico !== 'ext');
    },
    canCompleteData() {
      return this.onIncompleteFiles
        || (this.onGeneralFiles && this.file.estado === 9 && this.file.solicitanteCodigo !== 'si');
    },
    canSendDocDigital() {
      return this.onPreSalida && (this.file.estado === 10 || this.file.estado === 12);
    },
    canRespond() {
      return this.file.solicitanteDocumentoId !== this.currentUserId
        && this.file.estadoCodigoEstadoSistema !== 1;
    },
    canRecover() {
      if (this.onSupportFiles) {
        return this.file.estado === 6;
      }
      return this.file.solicitanteDocumentoId === this.currentUserId && this.file.estado === 6;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('Approvals', [
      'getApprovalFileDetails',
      'getAttachmentFiles',
      'getFileBinnacle',
      'getApprovalManagedFile'
    ]),
    async getFlowDetails() {
      if (this.isAguasAndinas) {
        return;
      }
      this.selectFile(this.file);
      this.loading = true;
      try {
        await Promise.all([
          this.getApprovalFileDetails({
            aprobacionId: 0,
            ejecucionId: this.file.aprobacionId
          }),
          this.getAttachmentFiles({
            aprobacionId: 0,
            ejecucionId: this.file.aprobacionId
          }),
          this.getFileBinnacle({
            documentoId: this.file.aprobacionId
          })
        ]);
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
      await this.showModals('flowFile');
    }
  }
};

</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}

.mother-indicator {
  width: 160px;
  margin-left: 50%;
  left: 80px;
}
</style>
